import { apiV1 } from './apiClient';

/**
 * Servicio para gestión de plantillas de proceso
 * Consume endpoints de backend/src/routes/v1/plantillasRoutes.js
 */
const plantillasApi = {
  /**
   * GET /api/v1/plantillas
   * Listar todas las plantillas disponibles
   * @returns {Promise<Array>} Lista de plantillas
   */
  getPlantillas: async () => {
    const response = await apiV1.get('/plantillas');
    return response.data;
  },

  /**
   * GET /api/v1/plantillas/:id
   * Obtener detalle de una plantilla específica
   * @param {number} id - ID de la plantilla
   * @returns {Promise<Object>} Detalle completo de la plantilla
   */
  getPlantilla: async (id) => {
    const response = await apiV1.get(`/plantillas/${id}`);
    return response.data;
  },

  /**
   * POST /api/v1/plantillas
   * Crear nueva plantilla (solo Admin Sistema)
   * @param {Object} plantillaData - Datos de la plantilla
   * @param {string} plantillaData.nombre_plantilla - Nombre de la plantilla
   * @param {string} plantillaData.descripcion - Descripción
   * @param {boolean} plantillaData.soporte_gis - Soporte para geolocalización
   * @param {Array<number>} plantillaData.estados_flujo_ids - IDs de estados del flujo
   * @returns {Promise<Object>} Plantilla creada
   */
  createPlantilla: async (plantillaData) => {
    const response = await apiV1.post('/plantillas', plantillaData);
    return response.data;
  },

  /**
   * PUT /api/v1/plantillas/:id
   * Actualizar plantilla existente (solo Admin Sistema)
   * @param {number} id - ID de la plantilla
   * @param {Object} plantillaData - Datos actualizados de la plantilla
   * @param {string} plantillaData.nombre_plantilla - Nombre de la plantilla
   * @param {string} plantillaData.descripcion - Descripción
   * @param {boolean} plantillaData.soporte_gis - Soporte para geolocalización
   * @param {Array<number>} plantillaData.estados_flujo_ids - IDs de estados del flujo
   * @returns {Promise<Object>} Plantilla actualizada
   */
  updatePlantilla: async (id, plantillaData) => {
    const response = await apiV1.put(`/plantillas/${id}`, plantillaData);
    return response.data;
  }
};

export default plantillasApi;
